import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Spin, Switch, Tabs } from "antd";
import { getroutinglevelsCountry } from "../../API/api";
import MultiSelectCM from "../MultiSelectCm/MultiSelectCm";
import countryList from "react-select-country-list";
export default function EditRoleAdmin({ data, onChangeFunc, roleId }) {
  if(data.attributes[roleId].routingLevels===undefined){
    data.attributes[roleId].routingLevels={};
  }
  const [state, setState] = useState({
    region:data.attributes[roleId].routingLevels.atr2 === undefined?[]:{name:data.attributes[roleId].routingLevels.atr2,value:data.attributes[roleId].routingLevels.atr2,label:data.attributes[roleId].routingLevels.atr2},
    currentCountry:data.attributes[roleId].routingLevels.atr1 === undefined?[]:{name:data.attributes[roleId].routingLevels.atr1,value:data.attributes[roleId].routingLevels.atr1,label:data.attributes[roleId].routingLevels.atr1},
    countryList:[],
  });
  const cmState = useSelector((state) => state.cmRoot);
  useEffect(()=>{
    if(data.attributes[roleId].routingLevels.atr2 !== undefined && state.countryList.length===0){
        getroutinglevelsCountry(data.attributes[roleId].routingLevels.atr2).then(res=>{
          if(res===undefined) return;
            setState({...state, countryList:res})
        })
    }
  },[])
  const onChangeRegion = (value) => {
    let origData = {...data};
    if(state.region.value===value.value){
      setState({...state, region: [],currentCountry:[],countryList:[] });
      delete origData.attributes[roleId].routingLevels.atr2;
      delete origData.attributes[roleId].routingLevels.atr1;
    }else{
      getroutinglevelsCountry(value.value).then(res=>{
        if(res===undefined) return;
        setState({...state, region: value,currentCountry:[],countryList:res });
        origData.attributes[roleId].routingLevels.atr2=value.value;
        delete origData.attributes[roleId].routingLevels.atr1;
    })
    }
  };
  const onChangeCountry = (value) => {
    let origData = {...data};
    if(state.currentCountry.value===value.value){
      setState({...state,currentCountry:[] });
      delete origData.attributes[roleId].routingLevels.atr1;
    }else{
      setState({...state,currentCountry:value });
      origData.attributes[roleId].routingLevels.atr1=value.value;
    } 
  };
  return (
    <>
        <div className="mt-2">
          <span style={{ fontSize: "16px" }}>
            Set Admin Location&nbsp;
          </span>
        </div>
        <div className="mt-3" style={{ display: "flex", marginBottom:'200px' }}>
          <div
            style={{
              width: "50%",
              display: "flex",
              alignItems: "baseline",
              flexWrap: "wrap",
            }}
          >
            <div style={{ fontSize: "14px" }}>
              Region&nbsp;
            </div>
            <div style={{ marginTop: "7px" }}>
              <MultiSelectCM
                value={state.region}
                options={cmState.regionData}
                isMulti={false}
                onChangeFunc={onChangeRegion}
                isClearable={true }
              />
            </div>
          </div>
          <div
            style={{
              width: "50%",
              display: "flex",
              alignItems: "baseline",
              flexWrap: "wrap",
            }}
          >
            <div style={{ fontSize: "14px" }}>
              Country&nbsp;
            </div>
            <div style={{ marginTop: "7px" }}>
              <MultiSelectCM value={state.currentCountry} options={state.region.length===0?[]:state.countryList} onChangeFunc={onChangeCountry}   isClearable={true}/>
            </div>
          </div>
        </div>
      </>
  );
}
